import { render, staticRenderFns } from "./ListPatients.vue?vue&type=template&id=3f8ad006&"
import script from "./ListPatients.vue?vue&type=script&lang=js&"
export * from "./ListPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports